import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import { getKatalogi } from '../../../dao/Katalog';
const useStyles = makeStyles({
    root: {
        minHeight: 410,
        flexGrow: 1,
        minWidth: 400,
        maxWidth: 400,
    },
});

export default function KatalogiTree(props) {
    const classes = useStyles();
    const [expanded, setExpanded] = useState([]);
    const [selected, setSelected] = useState([]);
    const [katalogi, setKatalogi] = useState(null);
 
    props.biRef.getSelectedItem = () => {
        return selected;
    }
    props.biRef.getSelected = () => {
        console.log("getSelected: " + selected);
        let kat;
        for (let i = 0; i < selected.length; i++) {
            console.log("getSelectedKat:  selected[i]  " + selected[i]);
            kat = getSelectedKat(selected[i], katalogi);
            console.log("getSelectedKat:kat  " + JSON.stringify(kat));
            if (kat) {
                console.log("getSelectedKat:return kat  " + JSON.stringify(kat));
                return kat;
            }
        }
        return null;
    }

    const getSelectedKat = (id_kat, items) => {
        console.log("getSelectedKat: items id_kat " + id_kat + ": " + JSON.stringify(items));
        for (let i = 0; i < items.length; i++) {
            console.log("item.id_kat == id_kat :" + items[i].id_kat + ": " + id_kat);
            if (items[i].id_kat == id_kat) {
                console.log("return item" + JSON.stringify(items[i]));
                return items[i];
            }
            if (items[i].has_children == "t") {
                let x;
                x = getSelectedKat(id_kat, items[i].children);
                if (x) {
                    return x;
                }
            }
        }
        return null;
    }

    async function fetchGetKatalogi(id_kat) {
        console.log("fetchGetKatalogi " + id_kat);
        if (katalogi && id_kat == "") {
            console.log("aktualizujDrzewo: katalogi && id_kat==");
            return;
        }
        let x = await getKatalogi(id_kat).catch(e => {
            return null;
        });
        console.log("fetchGetKatalogi " + (new Date()).toLocaleTimeString());
        if (!x) {
            console.log("błąd");
        } else {
            console.log("x.katalogi:" + JSON.stringify(x.katalogi));
            let l = aktualizujDrzewo(katalogi, x.katalogi)
            if (l) {
                setKatalogi(l.slice());
            }
        }
    };

    const aktualizujDrzewo = (node, child) => {
        console.log("aktualizujDrzewo node" + JSON.stringify(node));
        if (!node) {
            console.log("aktualizujDrzewo: !node");
            return child;
        }
        if (!(undefined !== child && child.length )) {
            console.log("child.length==0");
            return node;
        }
        if (child.length == 0) {
            console.log("child.length==0");
            return node;
        }
        for (let i = 0; i < node.length; i++) {
            console.log("aktualizujDrzewo: " + node[i].id_kat + ":" + child[0].id_pkat);
            if (node[i].id_kat == child[0].id_pkat) {
                console.log("aktualizujDrzewo set: " + node[i].id_kat + ":" + child[0].id_pkat);
                node[i].children = child;
                return node;
            } else if (node[i].has_children == "t") {
                let ret = aktualizujDrzewo(node[i].children, child);
                if (ret) {
                    node[i].children = ret;
                    return node;
                }
            }
        }
        return null;
    }

    useEffect(() => {
        console.log("fetchGetKatalogi: useEffect");
        fetchGetKatalogi("");
    }, []);

    const handleToggle = (event, nodeIds) => {
        console.log("handleToggle: nodeIds" + nodeIds);
        fetchGetKatalogi(nodeIds[0]);
        setExpanded(nodeIds);
    };

    const handleSelect = (event, nodeIds) => {
        setSelected(nodeIds);
        props.biRef.selected = selected;
    };
    //  {(nodes.has_children == "t") ? nodes.children.map((node) => renderTree(node)) : null}
    const pusty = (nodes) => {
      //  console.log("pusty:" + JSON.stringify(nodes));
        if (nodes.has_children == "t" && !nodes.children) {
            //    console.log("pusty sss:"+ JSON.stringify(nodes));
            nodes.children = [{ id_kat: "", id_pkat: "", nazwa: "",has_children:"f" }]
            return ( nodes.children.map((node) => renderTree(node)));
        }
        return ( nodes.children.map((node) => renderTree(node)));

    }
    const renderTree = (nodes) => {

        console.log("aaa1--" + nodes.id_kat);
        return (<TreeItem key={nodes.id_kat} nodeId={nodes.id_kat} label={nodes.nazwa}>
            {(nodes.has_children == "t") ? pusty(nodes) : null}
        </TreeItem>);
    };

    return (<>
        <TreeView
            className={classes.root}
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
            expanded={expanded}
            selected={selected}
            onNodeToggle={handleToggle}
            onNodeSelect={handleSelect}
            multiSelect
        >
            {
                (katalogi && katalogi.map((item, key) => (
                    renderTree(item)
                )))
            }

        </TreeView>
         </>
    );
}
